// extracted by mini-css-extract-plugin
var _1 = "WidgetHeader-moduleWidgetHeader__FAukr";
var _2 = "WidgetHeader-moduletitle__q6dn0";
export { _1 as "WidgetHeader", _2 as "title" }
